import { useQuery } from '@tanstack/react-query';
import { callUIAPI } from '@utils/apiUtils';

import { formatRunDate } from '../utils/companyIdentity';

const SCAN_RUN_DATE_KEY = ['onboarding', 'scanRunDate'];

/**
 * The day the scan ran, read once from `createdOn` on the scan row and shared
 * through the query cache. Every date on every wizard screen comes from here,
 * so no component formats its own and none of them can disagree.
 *
 * An unreadable row costs the date line and nothing else: callers get an empty
 * string and render the rest of their copy without it.
 */
export function useScanRunDate(): { runDate: string; isLoading: boolean } {
  const query = useQuery<string | null>({
    queryKey: SCAN_RUN_DATE_KEY,
    queryFn: async () => {
      const response = await callUIAPI('scans/latest', null, 'get', true) as
        { data?: { createdOn?: string } } | undefined;
      return response?.data?.createdOn ?? null;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return { runDate: formatRunDate(query.data), isLoading: query.isLoading };
}
